// extracted by mini-css-extract-plugin
module.exports = {"icon":"ContactUs_icon__m15_P","link":"ContactUs_link__-j4No"};